import React, { useState } from "react";
import avetar from "../../../assets/images/front/profile.webp";
import Dropdown from "../../form/Dropdown";

const MessageList = () => {
    const [activeMessageId, setActiveMessageId] = useState(null);
  const messages = [
    {
      id: 1,
      name: "Nitesh Chowdhary",
      message: "Nitesh sent an attachment",
      date: "Feb 24",
      avatar: avetar,
    },
    {
      id: 2,
      name: "Dilsha Mujeeb",
      message: "Dilsha: Hello I'm interested in working at your company....",
      date: "May 20, 2024",
      avatar: avetar,
    },
    {
      id: 3,
      name: "Aniket Paul",
      message: "Aniket: Hello",
      date: "Sep 29, 2023",
      avatar: avetar,
    },
    {
      id: 4,
      name: "Nitesh Chowdhary",
      message: "Nitesh sent an attachment",
      date: "Feb 24",
      avatar: avetar,
    },
    {
      id: 5,
      name: "Dilsha Mujeeb",
      message: "Dilsha: Hello I'm interested in working at your company....",
      date: "May 20, 2024",
      avatar: avetar,
    },
    {
      id: 6,
      name: "Aniket Paul",
      message: "Aniket: Hello",
      date: "Sep 29, 2023",
      avatar: avetar,
    },
  ];

  const profileMenu = [
    {
      _id: 1,
      name: "My Profile",
      icon: "fa-regular fa-user",
      //   link: notificationLink,
    },
    {
      _id: 2,
      name: "Create Company",
      icon: "fa-regular fa-plus",
      //   link: "/manage-company",
    },
    {
      _id: 3,
      name: "Help",
      icon: "fa-regular fa-circle-question",
      //   link: "/help",
    },
  ];

  const handleMessageClick = (id) => {
    setActiveMessageId(id); // Set clicked message as active
  };

  return (
    <div className="w-full bg-white max-h-[calc(100vh-320px)] overflow-auto">
      {messages.map((msg) => (
        <div
          key={msg.id}
          onClick={() => handleMessageClick(msg.id)}
          className={`flex items-center justify-between px-3 py-4 border-b border-b-gray-200 cursor-pointer group border-l-4 hover:bg-gray-100 ${
            activeMessageId === msg.id
              ? "bg-slate-100 border-emerald-800"
              : "border-transparent"
          }`}
        >
          <div className="flex items-center space-x-3 w-full">
            <img
              src={msg.avatar}
              alt={msg.name}
              className="rounded-full w-12 h-12 object-cover"
            />
            <div className="flex flex-col w-full">
              <div className="flex gap-2 items-start justify-between">
                <p className="font-medium text-gray-700 text-base">
                  {msg.name}
                </p>
                <span className="text-xs text-gray-800 pt-1 group-hover:hidden">
                  {msg.date}
                </span>
                <span className="hidden group-hover:block">
                  <Dropdown
                    data={profileMenu}
                    xPlacement="bottomRight"
                    dropdownContainer="w-72"
                    buttonClasses="p-0 border-0 !text-base text-gray-800 h-4"
                    variantClass=""
                    itemclasses="last:border-b-2"
                    button={<i class="fa-solid fa-ellipsis"></i>}
                  />
                </span>
              </div>
              <p className="text-xs text-gray-600">{msg.message}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageList;
